<template>
  <div class="page" v-wechat-title="$route.meta.title">
    <!--轮播图-->
    <div class="swiper-con border-box" style="position: relative;">
      <Swiper :banners="banners" :type="'view'"></Swiper>
    </div>

    <!--语音景区详情及目录切换-->
    <div class="tab-intro box border-box">
      <div @click="tabIntroCurr=1" class="flex tab-intro-btn01" :class="tabIntroCurr==1?'curr':''">
        <img class="scenic-icon" src="../../assets/scenic-icon1.png" alt="">
        <img class="scenic-icon-curr" src="../../assets/scenic-icon1-curr.png" alt="">
        <span>金牌解说</span>
      </div>
      <div @click="tabIntroCurr2" class="flex tab-intro-btn02" :class="tabIntroCurr==2?'curr':''">
        <img class="scenic-icon" src="../../assets/scenic-icon2.png" alt="">
        <img class="scenic-icon-curr" src="../../assets/scenic-icon2-curr.png" alt="">
        <span>景区简介</span>
      </div>
      <div @click="catalogueCurr1" class="flex tab-intro-btn03">
        <img class="scenic-icon" src="../../assets/scenic-icon5.png" alt="">
        <img class="scenic-icon-curr" src="../../assets/scenic-icon5-curr.png" alt="">
        <span>展览列表</span>
      </div>
    </div>
    <div class="split-line" style="height: .16rem;"></div>

    <!--语音列表-->
    <div class="voice-box" :class="tabIntroCurr==2?'none':''">
      <!--导游分类 @click='tablistClick(item.id)'-->
      <div class="list-tab">
        <div class="flex curr">官方解说</div>
        <div class="flex">专业解说</div>
        <div class="flex">明星解说</div>
        <div class="flex">学者解说</div>
        <div class="flex">达人解说</div>
      </div>

      <!--语音列表-->
      <div class="list border-box">
        <div class="list-box box">
          <!--左侧头像部分-->
          <div class="block list-img">
            <!--解说员头像-->
            <img class="icon-tx" src="../../assets/upload/csmp01.png" alt="">
            <div class="listen-btn-num">
              <img src="../../assets/icon-listen.png" alt="">
              <span>试听</span>
            </div>
          </div>
          <!--右侧语音内容部分-->
          <div class="block flex list-info">
            <!--语音名称-->
            <div class="list-name guide-name hide">王婕
              <span>博物馆专业讲解员</span>
            </div>
            <div class="list-group hide">
              <span class="fl hide">甜美导游带你游博物馆</span>
            </div>
            <!--标签-->
            <div class="mt6 clearfix">
              <div class="label-color">
                <img src="../../assets/icon-label-listen.png" alt="">
                <span>1362人收听</span>
              </div>>
              <div class="label-color">
                <img src="../../assets/icon-label-buy.png" alt="">
                <span>307人购买</span>
              </div>
            </div>
            <div class="sees-num-block clearfix">
              <div class="label-color">
                <img src="../../assets/icon-label-sees.png" alt="">包含45个景点解说
              </div>
            </div>
            <!--价格-->
            <div class="price-text-box clearfix">
              <div class="price-text">
                <div>10元 </div>
              </div>
            </div>
            <!--右侧购买收听按钮-->
            <button class="btn buy-btn buy-btn2">购买</button>
          </div>
        </div>
        <div class="list-box box">
          <!--左侧头像部分-->
          <div class="block list-img">
            <!--解说员头像-->
            <img class="icon-tx" src="../../assets/upload/csmp01.png" alt="">
            <div class="listen-btn-num">
              <img src="../../assets/icon-listen.png" alt="">
              <span>试听</span>
            </div>
          </div>
          <!--右侧语音内容部分-->
          <div class="block flex list-info">
            <!--语音名称-->
            <div class="list-name guide-name hide">王婕
              <span>博物馆专业讲解员</span>
            </div>
            <div class="list-group hide">
              <span class="fl hide">甜美导游带你游博物馆</span>
            </div>
            <!--标签-->
            <div class="mt6 clearfix">
              <div class="label-color">
                <img src="../../assets/icon-label-listen.png" alt="">
                <span>1362人收听</span>
              </div>>
              <div class="label-color">
                <img src="../../assets/icon-label-buy.png" alt="">
                <span>307人购买</span>
              </div>
            </div>
            <div class="sees-num-block clearfix">
              <div class="label-color">
                <img src="../../assets/icon-label-sees.png" alt="">包含45个景点解说
              </div>
            </div>
            <!--价格-->
            <div class="price-text-box clearfix">
              <div class="price-text">
                <div>10元 </div>
              </div>
            </div>
            <!--右侧购买收听按钮-->
            <button class="btn buy-btn buy-btn2">购买</button>
          </div>
        </div>
      </div>

      <div class="split-line" style="height: .16rem;"></div>

      <!--其他展馆-->
      <p class="jc-tit border-box">其他12个展馆</p>
      <ul class="zg-ul border-box clearfix">
        <li>
          <img src="../../assets/upload/csmp01.png" alt="">
          <p class="hide">飞虎奇兵馆</p>
        </li>
        <li>
          <img src="../../assets/upload/csmp01.png" alt="">
          <p class="hide">章钟印馆</p>
        </li>
        <li>
          <img src="../../assets/upload/csmp01.png" alt="">
          <p class="hide">不屈战俘馆</p>
        </li>
        <li>
          <img src="../../assets/upload/csmp01.png" alt="">
          <p class="hide">飞虎奇兵馆</p>
        </li>
      </ul>
    </div>

    <!--景区详情内容-->
    <div class="tab-scenic-box" :class="tabIntroCurr==1?'none':''">
      <!--景区地址-->
      <div class="scenic-padding border-box">
        <div class="scenic-details-title">景区地址</div>
        <div class="scenic-details-info mt13">{{shop.address}}</div>
      </div>

      <!--分隔行-->
      <div class="split-line h13"></div>
      <!--门票及开放时间信息-->
      <div class="scenic-padding border-box">
        <div class="scenic-details-title border-box">门票价格</div>
        <div class='scenic-details-info mt13'>{{shop.special=='0'?'免费':(shop.special+'元')}}</div>
        <div class="split-line" style="height: 1px;margin:.26rem 0;background: #f0f0f0;"></div>
        <div class="scenic-details-title">门票信息</div>
        <div class="scenic-details-info mt13" v-if="(shop.specialinfo=='')||(shop.specialinfo==null)||(!shop.specialinfo)">暂无信息</div>
        <div class="scenic-details-info mt13" v-html="shop.specialinfo" v-else></div>
        <div class="split-line" style="height: 1px;margin:.26rem 0;background: #f0f0f0;"></div>
        <div class="scenic-details-title border-box">开放时间</div>
        <div class="scenic-details-info mt13">{{(shop.linestime+shop.lineetime)=='00:0000:00'?'全天':(shop.linestime+'-'+shop.lineetime)}}</div>
      </div>

      <!--分隔行-->
      <div class="split-line h13"></div>
      <!--景区信息-->
      <div class="scenic-padding scenic-details-box border-box">
        <div class="scenic-details border-box">
          <div class="scenic-details-title border-box">景区信息</div>
          <!--<div class="scenic-details-info mt13">{{(shop.info=='')||(shop.info==null)||(!shop.info)?'暂无景区信息':shop.info}}</div>-->
          <div class="scenic-details-info mt13" v-if="(shop.info=='')||(shop.info==null)||(!shop.info)">暂无景区信息</div>
          <div class="scenic-details-info mt13" v-html="shop.info" v-else></div>
          <div class="scenic-details-title border-box mt26">游玩路线</div>
          <div class="scenic-details-info mt13">{{(routes=='')||(routes==null)||(!routes)?'暂无信息':routes}}</div>
        </div>
      </div>

      <!--分隔行-->
      <div class="split-line h13"></div>
      <!--景区助手-->
      <div class="scenic-padding border-box">
        <div class="scenic-details-title">景区助手</div>
        <div class="scenic-details-info mt13">建议游玩时长 {{(shop.routetime=='')||(shop.routetime==null)||(!shop.routetime)?'暂无信息':shop.routetime}}</div>
      </div>

    </div>

    <!--景点目录-->
    <div class="alert-box catalogue-box" :class="catalogueCurr==1?'curr':''">
      <div @click="catalogueCurr=0" class="mask"></div>
      <div class="catalogue-item border-box">
        <div class="font34 cor3">景点目录</div>
        <div class="catalogue-line"></div>
        <form class="catalogue-input" v-on:submit.prevent="getCatalist()">
          <input class="border-box" :placeholder="shop.name +'（'+ catalogueRoot.length + '个景点）'" value="" v-model='inputValue'/>
          <img src="../../assets/icon-search.png" alt="" @click='getCatalist()'>
        </form>
        <div class="catalogue-item-con border-box">
          <router-link v-for="(item,index) in catalogueRoot" :key="index" class="catalogue-name hide" @click.native='catalogueCurr=0':to="{path:'/spot-detail',query: {code:code,spotid:item.id,shopid:shopid,siteid:siteid,sregion:sregion,TimeStamp: TimeStamp, appKey: appKeyA}}">{{item.name}}</router-link>
        </div>
      </div>
    </div>

    <!--试听结束弹窗新版-->
    <AlertListenEnd  :bag="bag" :couponid="couponid" :extral="extral" :shopid="shopid" @close="closeEnd" v-if="Object.keys(bag).length>0"></AlertListenEnd>

    <!--提醒用户购买弹窗弹窗-->
    <AlertPayTip @close="closePayTip" :comeForm="0" v-if="buyTip==1"></AlertPayTip>

    <!--自定义富文本弹窗-->
    <AlertRichTxtTip @close="closeRichTxtTip" :comeForm="0" :shopname="shop.name" :richTxt="richTxt"  v-if="richTxt"></AlertRichTxtTip>

    <audio id="Audio" style="overflow: hidden" src="http://wangchuang-1252493175.coscd.myqcloud.com/jpjs/upload/voice/20181126/iosvoicetest.mp3"></audio>

    <!--系统维护蒙层-->
    <P400  v-if="P400==1"></P400>
  </div>

</template>

<script>

  import PhotoSphereViewer from 'photo-sphere-viewer'
  import 'photo-sphere-viewer/dist/photo-sphere-viewer.css'
  import { mapState, mapMutations } from 'vuex'
  import Swiper from '../../components/Swiper'
  import {getViewDetail, getBagTab, getCatalogue, uploadScan, getUserTui, uploadUserBrowse, getNotice,getRichTxt,siteBrother} from "@/service/getData";
  import {wxGetPosition,wxShareme,listenEndOrder, listenTurl, creatOrder, pushOrder} from '@/utils/wechat'
  import {setStore, getStore, removeStore, loadMore} from '@/config/mUtils'
  import AlertListenEnd from '../../components/AlertListenEnd'
  import AlertPayTip from '../../components/AlertPayTip'
  import AlertRichTxtTip from '../../components/AlertRichTxtTip'
  import P400 from '../../components/P400'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return {
        code: this.$route.query.code || '', //城市站点id
        siteid:'',//站点id
        sregion:'',//省站点id:430000
        qrcode: '', //是否是扫码
        qid: '', //扫码id
        shopid: '', //景区id
        spotid: '', //景点id
        userInfo: {}, //用户信息
        inputValue: '',//搜索关键词
        page: 1,
        rows: 10,
        loadText: "数据加载中",
        res: "", //全部数据
        cid: "", //导游筛选
        bagList: [],//解说列表
        total: '',//解说总数
        banners: [], //banner图片或者video
        shop: '',//景区信息
        routes: '',//游玩路线
        tlist: [],//推荐列表
        tablist: [],//导游分类列表
        tabIntroCurr: 1,//语音、景区详情及目录切换
        catalogueCurr: 0,//目录弹窗
        catalogueRoot: [],//目录弹窗内容
        personEnvelopes: [], //红包人物
        redEnvelopes: [], //国庆红包数据
        redEnvelNew: [], //攀枝花类型的普通红包
        recommendPerson: '', //推荐人物专辑数据
        recommendYear: '', //推荐人物专辑数据+音频
        userTui: '', //推荐弹窗类型
        buyTip: 0, //购买提醒弹窗
        richTxtTip: 1, //自定义富文本弹窗
        richTxt: '',//自定义弹窗内容

        Audio: '', //音频dom
        videoTimer: null, //语音播放计时器
        currIndex: -1, //当前播放音频数组下标
        index1: 0, //当前播放音频数组下标(用来记录currIndex，传值给下订单方法)
        bag:{}, //当前试听的专辑
        extral:{}, //存放下单需要的值
        couponid: '', //优惠券id
        listType: '', //所点击的语音列表类型‘tjList:推荐列表’，‘bagList:其他列表’
        lastListType: '', //记录上一次所点击的语音列表类型‘tjList:推荐列表’，‘bagList:其他列表’

        TimeStamp: new Date().getTime(),  //获取当前时间
        appKey: '',
        appKeyA: '',
        posterShow: 0, //分享海报弹窗

        VRlist: [], //VR视频列表
        VRtotal: 0, //VR视频专辑总数
        focusEwmShow:0,//二维码弹窗0：隐藏   1：显示
        focusRes:'',//二维码弹窗数据

        videoList: [], //视频列表
        videoTotal: 0, //视频专辑总数

        P400: 0, //系统维护中
        PSV: null, //全景图片
        loadPSV: false, //全景是否加载完
      }
    },
    computed: {

    },
    created(){
      this.$loading.show('数据加载中');
      this.shopid = this.$route.query.shopid;
      this.userInfo = getStore("userInfo");
      this.appKey = this.$route.query.appKey || "";
      this.appKeyA = this.appKey;
      if(this.appKey){
        this.appKey = encodeURIComponent(this.appKey)
        setStore("appKey", {"appKey":this.appKey});
        this.sendUserBrowse();
      }else{
        setStore("appKey", {"appKey":""});
      }
      this.siteid = this.$route.query.siteid || getStore("siteid") || "";
      if (this.siteid != "" && this.siteid != null && this.siteid != undefined) {
        setStore("siteid", this.siteid);
        removeStore("sregion")
      }
      this.sregion = this.$route.query.sregion || getStore("sregion") || "";
      if (this.sregion != "" && this.sregion != null && this.sregion != undefined) {
        setStore("sregion", this.sregion);
        this.siteid = '';
        removeStore("siteid")
      }
      this.initData(this.page);
      this.getTablist();
      this.getCatalist();

      this.qrcode = this.$route.query.qrcode;
      this.qid = this.$route.query.qid;
      if(this.qid){
        setStore("qid", {"qid":this.qid});
      }
      if(this.qrcode){
        let self = this;
        wxGetPosition(function(res){
          self.sendScan(res.latitude,res.longitude);
        });
      }
      this.getBuyNotice();
      this.getRichTxt();

//      window.addEventListener("scroll",this.handleFun)
    },
    beforeDestroy(){
//      window.removeEventListener("scroll",this.handleFun);
      if(this.videoTimer){
        clearInterval(this.videoTimer);
        this.currIndex = -1;
        this.bagList[this.index1].isplay = 0;
        this.tlist[this.index1].isplay = 0;
        this.bag = {};
      }
      if (this.PSV) {
        this.PSV.destroy()
      }
    },
    methods: {

      //获取语音+景区+推荐信息
      async initData(page){
        let res = await getViewDetail({
          TimeStamp: this.TimeStamp,
          openid: this.userInfo.openid,
          page: this.page,
          rows: 100,
          shopid: this.shopid,
          cid: this.cid
        });

        if (res.errcode === "00000"){
          this.$loading.hide();

          this.res = res.data;
          this.focusRes = res.data;
          this.banners = res.data.bannerinfo;
          this.shop = res.data.shop;
          this.routes = res.data.routes;
          for(var i=0; i<res.data.tlist.length; i++){
            res.data.tlist[i].isplay = 0;
            res.data.tlist[i].toaTime = '';
            res.data.tlist[i].resTime = '';
          }
          this.tlist = res.data.tlist;

          this.total = res.data.total;
          for(var i=0; i<res.data.root.length; i++){
            res.data.root[i].isplay = 0;
            res.data.root[i].toaTime = '';
            res.data.root[i].resTime = '';
          }
          this.bagList = res.data.root;
    //      if (page >= Math.ceil(this.total / this.rows) || bagList.length >= this.total) {
    //        this.loadText = '已经到底了'
    //      } else {
    //        this.loadText = '加载更多'
    //      }
    //      if (bagList.length > 0) {
    //        this.bagList = [...this.bagList, ...bagList];
    //      } else {
    //        if (page == 1) {
    //          this.bagList = [];
    //          this.loadText = '暂无数据'
    //        } else {
    //          this.loadText = '已经到底了'
    //        }
    //      }

          var share = res.data.share;
          let link = '/view-detail?shopid='+ this.shopid +'&siteid='+ this.siteid + '&sregion='+ this.sregion  +'&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey);
          if(share == null){
            let title = '金牌解说 | ' + this.shop.name;
            let desc = '历史会说话！金牌解说为您讲解' + this.shop.name + '的历史故事';
            let img = this.banners[0].img;
            wxShareme(title,desc,img,link);
          }else {
            wxShareme(share.title,share.desc,share.logo,link);
          }

          this.$route.meta.title = this.shop.name;

        }else {
          this.$toast(res.errmsg)
          this.P400 = 1;
          this.$route.meta.title = '请稍后访问...';
        }

      },

      //提醒用户购买弹窗
      async getBuyNotice(){
        let res = await getNotice({
          TimeStamp: this.TimeStamp,
          openId: this.userInfo.openid
        });
        if (res.errcode === "00000"){
          this.buyTip = 1;
        }
      },

      //自定义弹窗
      async getRichTxt(){
        let res = await getRichTxt({
          TimeStamp: this.TimeStamp,
          shopid: this.shopid,
          openid: this.userInfo.openid
        });
        if (res.errcode === "00000"){
          console.log(res)
          this.richTxt = res.data.smallcontent;
        }
      },



      //上传扫码数据
      async sendScan(lat,lng){
        let res = await uploadScan({
          openid: this.userInfo.openid,
          shopid: this.shopid,
          qid: this.qid || "",
          lat: lat || "",
          lng: lng || ""
        });
      },

      //上传浏览数据
      async sendUserBrowse(){
        this.userInfo = getStore("userInfo");
        let res = await uploadUserBrowse({
          openid: this.userInfo.openid,
          appKey: this.appKey,
        });
      },

      //请求导游分类
      async getTablist(){
        let res = await getBagTab({
          TimeStamp: this.TimeStamp,
          openid:  this.userInfo.openid,
          shopid: this.shopid
        });
        if (res.errcode === "00000"){
          this.tablist = res.data.root
        }
      },

      //请求景点目录
      async getCatalist(){
        let res = await getCatalogue({
          TimeStamp: this.TimeStamp,
          type: 0,
          id: this.shopid,
          name: this.inputValue
        });
        if (res.errcode === "00000"){
          this.catalogueRoot = res.data.root
        }
      },

      //导游分类列表切换
      tablistClick(cid){
        MtaH5.clickStat("view_detail_tab");
        if(this.videoTimer != null){
          this.Audio.pause();
          clearInterval(this.videoTimer);
        }
        this.currIndex = -1;
        for(var i=0; i<this.bagList.length; i++){
          this.bagList[i].isplay = 0;
        }
        this.bag = {};

        this.$loading.show('数据加载中');
        this.loadText = '数据加载中'
        this.page = 1;
        this.bagList = [];
        this.cid = cid;

        this.initData(this.page);
      },

      //点击试听，调用试听公用方法
      listenTurlClick(ind,listType){
        MtaH5.clickStat('view_detail_listen');
        MtaH5.clickStat('xiangqingyeshit',{'viewdetaillisten':'true'});//景区、景点》1试听弹窗》购买》支付
        MtaH5.clickStat('jingqujingdiana-1',{'1listen':'true'});//景区景点1试听》直接购买》支付
        this.lastListType = this.listType;
        this.listType = listType;

        if(listType == 'tjList'){
          listenTurl(this,ind,this.tlist)
        }else {
          listenTurl(this,ind,this.bagList)
        }

      },

      //点击购买，调用下订单公用方法
      buyVideoVr(id){
        let self = this;
        setStore("source", {"source": "video"});
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+id+'&cid='+self.couponid+'&shopid='+self.shopid+'&bagtype=2'+'&appKey='+(self.appKey)}`
        });
      },

      //点击购买，调用下订单公用方法
      buyVideo(ind,listType){
        MtaH5.clickStat("view_detail_buy");
        MtaH5.clickStat('zhuanjixiangqin',{'choose':'true'});//专辑详情页点击推荐景区》1购买》支付
        MtaH5.clickStat('viewspotbuy',{'1viewspotbuy':'true'});//景区景点直接点击1购买》支付
        MtaH5.clickStat('jingqujingdiana-1',{'2buy':'true'});//景区景点试听》1直接购买》支付
        this.listType = listType;
        let list = listType == 'tjList' ? this.tlist[ind] : this.bagList[ind] ;
        let self = this;

        setStore("source", {"source": "index"})
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+list.id+'&cid='+self.couponid+'&shopid='+self.shopid+'&appKey='+(self.appKey)}`
        });
      },

      buyVideo1(ind,listType){
        MtaH5.clickStat("view_detail_buy");
        this.listType = listType;
        let list = listType == 'tjList' ? this.tlist[ind] : this.bagList[ind] ;
        let self = this;
        setStore("couponid", {"couponid": ""});
        self.$router.push({
          path: `/pay?${'pid='+list.id+'&cid='+self.couponid+'&shopid='+self.shopid+'&bagtype=1'+'&appKey='+(self.appKey)}`
        });

      },

      //关闭试听弹窗，购买成功修改音频状态
      closeEnd(msg){
        this.bag = msg.bag;
        if(msg.isbuy){
          if(this.listType == 'tjList'){
            this.tlist[this.index1].buy = 12;
          }else {
            this.bagList[this.index1].buy = 12;
          }
        }
      },


      //关闭购买提醒弹窗
      closePayTip(msg){
        this.buyTip = msg;
      },
      //
      closeRichTxtTip(msg){
        this.richTxt = msg;
      },

      //跳转到专辑详情页
      goVideoPlay(ind,listType,rewardShow){
        MtaH5.clickStat('jingqujingdiana-2',{'1tovideo':'true'});//景区景点1进入专辑详情》点击购买》支付
        MtaH5.clickStat('jingqujingdiana-3',{'1tovideo':'true'});//景区景点1进入专辑详情》试听》购买》支付
        MtaH5.clickStat('jingqujingdiana-4',{'1tovideo':'true'});//景区景点1进入专辑详情》试听》弹窗购买》支付

        this.listType = listType;
        let list = this.listType == 'tjList' ? this.tlist : this.bagList ;
        if(rewardShow){
          this.$router.push({
            path: `/video-play?${'id='+list[ind].id+'&spotid='+list[ind].spotid+'&shopid='+this.shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey+'&rewardShow=1'}`
          });
        }else {
          if((list[ind].buy!=12)&&(!list[ind].isuser)){
            MtaH5.clickStat('list_detail_button')
          }
          this.$router.push({
            path: `/video-play?${'id='+list[ind].id+'&spotid='+list[ind].spotid+'&shopid='+this.shopid+'&TimeStamp='+this.TimeStamp+'&appKey='+this.appKey}`
          });
        }
      },


      //跳转到导游详情页
      goGuideInfo(id){
        MtaH5.clickStat("view_detail_person");
        MtaH5.clickStat('jingqujingdiana',{'1guide':'true'});//景区景点1点击导游头像》个人主页购买》支付
        this.$router.push({
          path: `/guide-info?${'id='+ id + '&TimeStamp='+ this.TimeStamp+'&appKey='+(this.appKey)}`
        });
      },

      //景区介绍
      tabIntroCurr2(){
        this.tabIntroCurr = 2;
        MtaH5.clickStat('view_detail');
      },

      //景点目录
      catalogueCurr1(){
        this.catalogueCurr = 1;
        MtaH5.clickStat("catalogue");
      },

    },
    watch:  {
      bag(newVal,oldVal){
        if(Object.keys(newVal).length){
          let list = this.listType == 'tjList' ? this.tlist : this.bagList ;
          listenEndOrder(this,this.index1,list);
        }
      },
      VRlist(){
        var self = this;
        this.$nextTick(function(){
          if(self.VRlist[0].vrimg && self.VRlist[0].vrimg != '' && self.VRlist[0].vrimg != null){
            self.showPhotoVR(self.VRlist[0].vrimg,'video-vr-img');
          }
        })
      },
    },
    components: {
      Swiper,
        AlertListenEnd,
        AlertPayTip,
        AlertRichTxtTip,
        P400
    },
    //格式化数据
    filters: {
      initNumber: function (num) {
        if(num>10000){
          num = (num/10000).toFixed(2)+'万'
        }else if(num>1000){
          num = (num/1000).toFixed(2)+'千'
        }
        return num;
      }
    }
  }

</script>

<style scoped>
  @import "../../style/alert.css";
  @import "../../style/voice.css";
  .page{ padding-bottom:.4rem; }
  /*轮播图*/
  .swiper-con{width:100%;height: 3.75rem;}
  .swiper-box,.swiper-box .swiper-container{border-radius: 0!important;}

  /*语音、详情、目录切换*/
  .tab-intro {position: relative;height:1.04rem;text-align:center;color:#3c403b;background:#fff;border-radius:.3rem .3rem 0 0;margin-top:-.3rem;z-index: 1;}
  .tab-intro img {display: block;width:.48rem;height:.48rem;margin:.16rem auto 0;}
  .tab-intro img.scenic-icon-curr{display: none;}
  .tab-intro span {margin-top:.06rem;font-size:.2rem;font-weight:bold;color: #3c403b;}
  .tab-intro .flex.curr .scenic-icon-curr {display: block;}
  .tab-intro .flex.curr .scenic-icon {display: none;}
  .tab-intro .flex.curr span {color: #fcba5a;}

  /*导游分类*/
  .list-tab {width: 100%;height:.82rem;line-height:.82rem;background:#fff;border-bottom:1px solid #f3f3f3;white-space:nowrap;overflow-x: auto;}
  .list-tab .flex {position:relative;display: inline-block;width:22%!important;height:.8rem;line-height:.8rem;text-align:center;font-size:.28rem;color:#666;  }
  .list-tab .flex.curr{color: #000;}
  .list-tab .flex.curr:after{content:'';position:absolute;bottom:0;left:50%;right:0;width:.24rem;height:.12rem;background:#f8ab39;border-radius: .12rem .12rem 0 0;transform: translateX(-50%);z-index:1;}
  .special .list-tab{display:-webkit-box;display:box;}
  .special .list-tab .flex{display:block;width:initial;-webkit-box-flex:1;box-flex:1;}


  /*新版景区景点详情*/
  .scenic-padding{padding:.26rem .24rem;background:#fff;font-weight:bold;color:#555;}
  .scenic-details-box{position:relative;background: #fff;}
  .scenic-details-box.curr .scenic-details{height:auto;}
  .scenic-details-title{position:relative;font-size:.3rem;}
  .scenic-details-info{line-height:.4rem;font-size:.26rem;font-weight: normal;}

  .list{padding: .15rem .24rem;}
  .list-box{padding: .15rem 0;}
  .btn.buy-btn2{width: 1.48rem;height: .6rem;font-size: .32rem;line-height: .6rem;}

  .jc-tit{width: 100%;height: 1.12rem;padding-left:.3rem;font: bold .32rem/1.12rem "Microsoft YaHei";color: #3d3d3d;}
  .zg-ul{width: 100%;height: 2.44rem;padding: 0 .3rem;white-space: nowrap;overflow-x: auto;}
  .zg-ul li{position:relative;display:inline-block;width: 2.14rem;height: 100%;margin-right: .14rem;}
  .zg-ul li img{width: 100%;height: 1.68rem;border-radius: .08rem;object-fit: cover;}
  .zg-ul li p{margin-top: .12rem;font: .28rem/1.2 "Microsoft YaHei";color: #3d3d3d;text-align: center;}
</style>



// WEBPACK FOOTER //
// src/page/view-detail/view-detail-jc2.vue